import { ThemeNames } from '../themes';

export enum ChartPeriod {
  decrease = 'decrease',
  increase = 'increase',
}

const lineColors = {
  decrease: 'rgba(229, 89, 78, 1)',
  increase: 'rgba(48, 191, 163, 1)',
};

const chartColors = {
  decrease: 'rgba(229, 89, 78, 0.1)',
  increase: 'rgba(48, 191, 163, 0.1)',
};

export const getChartColor = (period: ChartPeriod) =>
  ({
    decrease: {
      bottomColor: chartColors.decrease,
      lineColor: lineColors.decrease,
      topColor: chartColors.decrease,
    },

    increase: {
      bottomColor: chartColors.increase,
      lineColor: lineColors.increase,
      topColor: chartColors.increase,
    },
  })[period];

interface ThemeColors {
  accentColor1: string;
  accentColor2: string;
  mainColor: string;
  tooltipBackground: string;
}

const darkTheme = {
  accentColor1: 'rgba(73, 83, 96, .3)',
  accentColor2: 'rgba(73, 83, 96, 1)',
  mainColor: 'rgba(255, 255, 255, 1)',
  tooltipBackground: 'rgba(40, 49, 60, 1)',
};

const lightTheme = {
  accentColor: 'rgba(212, 219, 231, .3)',
  accentColor2: 'rgba(212, 219, 231, 1)',
  mainColor: 'rgba(44, 51, 63, 1)',
  tooltipBackground: 'rgba(255, 255, 255, 1)',
};

const createThemes = () => {
  const themes = new Map();
  themes.set('dark', { ...darkTheme });
  themes.set('highContrast', { ...darkTheme, tooltipBackground: 'rgba(0, 0, 0, 1)' });
  themes.set('antique', { ...darkTheme, tooltipBackground: 'rgba(0, 0, 0, 1)' });
  themes.set('light', { ...lightTheme });
  return themes;
};
const themes = createThemes();

export const getThemeColors = (themeId: ThemeNames): ThemeColors => themes.get(themeId);
